import { useState } from "react";
import { useNavigate } from 'react-router-dom';

export default function CompleteOAuth() {
  const navigate = useNavigate();

  const [from, _] = useState(() => {
    return window.localStorage.getItem("from");
  });

  const onClickFinish = () => {
    if (from == null) {
      navigate('/');
    } else {
      navigate('/');
      window.close();
    }
  }

  return (
    <div className="h-screen w-full flex flex-col justify-center items-center">
      <img src="/assets/gifs/completed.gif" alt="completed" className="w-1/2 mb-14" />
      <h1 className="text-2xl font-bold mb-2">인증이 완료되었습니다.</h1>

      <h1 className="text-lg font-bold">창을 닫고 그림을 생성해보세요!</h1>

      <div className="w-full flex justify-center items-center mt-10">
        <button
          className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded w-full ml-24 mr-24"
          onClick={() => onClickFinish() }
        >
          서비스 이용하기
        </button>
      </div>

    </div>
  )
}